module.exports = __webpack_public_path__ + "img/SellAnywhere_Social1.436332d3.png";